import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-layout-column',
  templateUrl: './layout-column.component.html',
  styleUrls: ['./layout-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass]
})
export class LayoutColumnComponent {
  width = input.required<number>();
  size = input<string>('xs');
  offset = input<number>(0);
  pull = input<number>(0);
  push = input<number>(0);

  classNames = computed(() => [
    `col-${this.size()}-${this.width()}`,
    ...this.offset() > 0 ? [`col-${this.size()}-offset-${this.offset()}`] : [],
    ...this.pull() > 0 ? [`col-${this.size()}-pull-${this.pull()}`] : [],
    ...this.push() > 0 ? [`col-${this.size()}-push-${this.push()}`] : [],
  ]);
}
